/** Converte ISO/UTC para valor de input `datetime-local` (hora local). */
export function toLocalDateTimeInputValue(iso?: string | null): string {
  if (!iso) return '';
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '';
  const pad = (value: number) => String(value).padStart(2, '0');
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/**
 * Converte valor de `datetime-local` para ISO.
 * Retorna `null` se incompleto/inválido (digitação parcial no teclado).
 * Retorna `''` se o campo estiver vazio.
 */
export function fromLocalDateTimeInputValue(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return '';
  if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}/.test(trimmed)) {
    return null;
  }

  const date = new Date(trimmed);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toISOString();
}
